export default {
  "sandbox.detail.head.siteName": "SANDBOX",
  "sandbox.detail.pageTitle": "SANDBOX",
  "sandbox.list.head.title": "SANDBOX",

  "sandbox.list.head.description": "",
  "sandbox.list.head.siteName": "",
  "sandbox.list.title": "",
  "sandbox.list.heading.title": "",
  "sandbox.list.lead1": "",
  "sandbox.list.lead2": "",
  "sandbox.list.lead3": "",
  "sandbox.list.lead4": "",
  "sandbox.list.lead5": "",
  "sandbox.list.index.breadcrumbs": "",
  "sandbox.categories.scoop": "",
  "sandbox.categories.link-j-sandbox": "",
  "sandbox.categories.index": "",
} as const;
